import { TaxonomyIdItem } from "@amzn/taxonomy-lib";
import { AIForMeTool } from "lib/models/aiforme-models";
import { CatalogicalService } from "lib/services";
import { CSRFService } from "lib/services/csrf-service";

export type TrackClickInteraction = (taxonomyId: TaxonomyIdItem) => void;

/**
 * Creates a click interaction tracker function for AI For Me tools.
 * This tracks when users click on "Learn More" links to view tool details.
 *
 * @param catalogicalService - The CatalogicalService instance for posting interactions
 * @param csrfService - The CSRFService instance for obtaining CSRF tokens
 * @returns A function that tracks click interactions for a given taxonomy ID
 */
export const createTrackClickInteraction = (
  catalogicalService: CatalogicalService<AIForMeTool>,
  csrfService: CSRFService
): TrackClickInteraction => {
  return (taxonomyId: TaxonomyIdItem) => {
    try {
      csrfService
        .getToken()
        .then((token) => {
          catalogicalService.postInteraction(taxonomyId, token).catch((error) => {
            // Log error but don't disrupt user experience
            console.error("Failed to track interaction:", error);
          });
        })
        .catch((error) => {
          // Log error but don't disrupt user experience
          console.error("Failed to get CSRF token:", error);
        });
    } catch (error) {
      // Log error but don't disrupt user experience
      console.error("Error tracking interaction:", error);
    }
  };
};
